import { withStyles, makeStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import LocaleKeys from '../../../../locales/keys';
import { Grid, Button, Box } from '@material-ui/core';

import RetentionTermsAndConditions from '../retentionTermsAndConditions';
import RetentionNotForYouBox from '../retentionNotForYouBox';

const useStyles = makeStyles((theme) => ({
  postCancellationSpacer: {
    height: '24px',
  },
}));

const RetentionActions = (props) => {
  const {
    redeemOfferAction,
    keepMySubscriptionAction,
    continueCancellationAction,
    termsAndConditionLinkAction,
    terminationReasons,
    discountDetails,
    subscriptionProps,
    isPostCancellationFlow,
  } = props;
  const { t } = useTranslation();
  const styles = useStyles();

  const DialogButtonAction = withStyles(styles)((props) => {
    const { children, classes, handleClose, ...other } = props;
    return (
      <Button
        autoFocus
        className={`${classes.button} ${classes.closeButtonContent}`}
        onClick={handleClose}
        {...other}
      >
        {children}
      </Button>
    );
  });

  return (
    <>
      <Grid container direction="row" justifyContent="center" xm={0}>
        <DialogButtonAction
          size="large"
          style={{
            width: '100%',
            marginTop: '24px',
            marginLeft: '16px',
            marginRight: '16px',
            height: '40px',
            backgroundColor: '#E10600',
            borderRadius: '4px',
            color: '#FFF',
          }}
          handleClose={redeemOfferAction}
        >
          {t(LocaleKeys.retention.retentionRedeemOffer)}
        </DialogButtonAction>
        <DialogButtonAction
          size="large"
          style={{
            fontWeight: 600,
            textTransform: 'none',
            padding: '0px',
            marginTop: '16px',
            borderRadius: '0px',
            height: '20px',
            fontSize: '15px',
            color: '#FFF',
            borderBottom: '2px solid #E10600',
          }}
          handleClose={keepMySubscriptionAction}
        >
          {t(LocaleKeys.retention.retentionKeepMySubscription)}
        </DialogButtonAction>
      </Grid>

      <RetentionTermsAndConditions
        termsAndConditionLinkAction={termsAndConditionLinkAction}
        discountDetails={discountDetails}
        subscriptionProps={subscriptionProps}
      ></RetentionTermsAndConditions>

      {!isPostCancellationFlow ? (
        <RetentionNotForYouBox
          terminationReasons={terminationReasons}
          continueCancellationAction={continueCancellationAction}
        ></RetentionNotForYouBox>
      ) : (
        <Box className={styles.postCancellationSpacer}></Box>
      )}
    </>
  );
};

export default RetentionActions;
